var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Distributor in Korea",
      "tabActive": "ENDO Metal-Sleeve",
      "bg": "/images/sub/visual/sv3.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit mb-lg-42"
  }, [_vm._v(" ENDO Metal-Sleeve ")])]), _c('sub-bg-image', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-top-img.png",
      "className": "h-lg-540px"
    }
  }, [_c('h3', {
    staticClass: "tit font-weight-semibold mb-8 mb-md-50 mb-lg-100"
  }, [_vm._v(" Endo's Metal Sleeve business uses metal plasticity processing technology that we've developed on our own. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-10"
  }, [_vm._v(" The high level of technology developed contributes to the enhancement of the products which requires precise quality. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-10"
  }, [_vm._v(" Manufacturing capability enabling mass production with high quality has been established. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-10"
  }, [_vm._v(" That quality and technology has attracted attention from a variety of industries and has the great possibilities. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-10"
  }, [_vm._v(" Endo's Metal Sleeve business started from the progress of our metal plasticity processing technology. ")]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" The metal sleeve that we've developed through long term research makes possible seamless metal processing to a micro-thinness of approximately 10μ and is essential as functional parts for high-performance OA equipment for which we are now gaining a large market share. ")])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Advantages"
    }
  }, [_c('v-row', [_c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/endo/endo-icon1.png",
      "iconWidth": "50",
      "num": "01"
    }
  }, [_vm._v(" Maximize the advancement of products that require precise quality with high technology ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/endo/endo-icon2.png",
      "iconWidth": "50",
      "num": "02"
    }
  }, [_vm._v(" A production system that enables mass production while maintaining high quality ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/endo/endo-icon3.png",
      "iconWidth": "50",
      "num": "03"
    }
  }, [_vm._v(" Technology and quality are attracting attention in various industries and have great potential ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/endo/endo-icon4.png",
      "iconWidth": "50",
      "num": "04"
    }
  }, [_vm._v(" Ultra-Thin Seamless metal processing is possible, and functional parts essential for high-performance OA equipment ")])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "ENDO Metal-Sleeve",
      "className": "full"
    }
  }, [_c('v-row', {
    staticClass: "my-n10 my-lg-n40"
  }, [_c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('image-detail', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img3-1.png"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" Ultra-Thin Seamless Pipe ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail min-h-xl-120px"
  }, [_vm._v(" By being able to do ultra-thin processing to a wall thickness of less than 40μm, we have made it possible to bend a sleeve like a resin film. Excellent heat resistance, corrosion resistance, wear resistance, and rigidity. ")]), _c('standard', {
    attrs: {
      "diameter": "From φ18mm toφ45mm",
      "weight": "From 27μm to 100μm",
      "length": "Up to 420mm"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('image-detail', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img3-2.png"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" Thin Seamless Pipe ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail min-h-xl-120px"
  }, [_vm._v(" Achieves processing of wall thickness of less than 100μm that would be very hard to achieve with other production methods. Can be used as thin seamless pipe featuring high temperature strength and corrosion resistance. ")]), _c('standard', {
    attrs: {
      "diameter": "From φ10mm to φ30mm",
      "weight": "From 100μm to 300μm",
      "length": "Up to 420mm"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('image-detail', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img3-3.png"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" Ultra-Thin Seamless Belt ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail min-h-xl-120px"
  }, [_vm._v(" Excellent heat resistance and corrosion resitance. Additionally, by applying a formula to improve fatigue, it exhibits excellent characterisitics as a base material for drive transmission belt. ")]), _c('standard', {
    attrs: {
      "diameter": "From φ20mm toφ160mm",
      "weight": "From 15μm to 60μm",
      "length": "From 3mm to 400mm"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('image-detail', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img3-4.png"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" Small Diameter, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" Ultra-Thin Seamless Ring ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail min-h-xl-120px"
  }, [_vm._v(" Seamless ring for small diameter, thin applications. Minimum thickness of t15μm and under consideration for medical equipment parts. ")]), _c('standard', {
    attrs: {
      "diameter": "From φ3mm toφ30mm",
      "weight": "From 15μm to 60μm",
      "length": "From 3mm"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('image-detail', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img3-5.png"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" Small Diamete, Ultra-Thin "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" Seamless Pipe ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail min-h-xl-120px"
  }, [_vm._v(" Seamless pipe for small diameter, thin applications. Minimum thickness of t15μm and under consideration for electrical equipment, medical equipment and automobile parts. ")]), _c('standard', {
    attrs: {
      "diameter": "From φ3mm toφ10mm",
      "weight": "From 15μm to 100μm",
      "length": "Up to 400mm"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('image-detail', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img3-6.png"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" Seamless Case "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" with Bottom ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail min-h-xl-120px"
  }, [_vm._v(" Excellent corrosion resistance since there is no welded area on the bottom or cylindrical part. Exhibits excellent characteristics, even in harsh usage environments. Has a recrord of being under consideration as a case for batteries. ")]), _c('standard', {
    attrs: {
      "diameter": "From φ20mm toφ60mm",
      "weight": "From 50μm to 300μm",
      "length": "From 50mm to 400mm"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('inquiry', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img1.png",
      "name": "J.H HWANG",
      "tel": "+82-31-765-2268",
      "mail": "hwangjoe@ist-co.kr",
      "fax": "+82-31-765-2389",
      "link": "http://endo-mfg.co.jp/eng/",
      "linkBg": "/images/sub/distributor/endo/endo-img2.png"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }